<div class="country-info-view__content">
    <div class="country-info-view__main-info">
        <div class="country-info-view__breadcrumb">
            <app-simple-breadcrumb [breadcrumbs]="breadcrumbs"></app-simple-breadcrumb>
        </div>

        <div class="info-box">
            <div class="info-box__intro">
                <div class="info-box__texts">
                    <h2>About {{ defaultLocationName | replaceStr: ' ' | titlecase }}</h2>
                    <div class="extra-info-box">
                        @if (!isFetching) {
                            <app-text-ellipsis
                                    [short]="countryResponse.countryInfo.getFirstCountry().shortDescription"
                                    [long]="countryResponse.countryInfo.getFirstCountry().description"
                                    [extra]="countryResponse.countryInfo.getFirstCountry().extraDescription"
                            ></app-text-ellipsis>
                        } @else {
                            <ngx-skeleton-loader [theme]="{height: '20px', margin: 0}"></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                                    [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                                    [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                                    [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                            <ngx-skeleton-loader
                                    [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                        }
                    </div>
                </div>

                <div class="info-box__anchors">
                    <p>
                        More in {{ defaultLocationName | replaceStr: ' ' | titlecase }}
                    </p>
                    <ul>
                        @if (countryResponse?.regions?.length || isFetching) {
                            <li>
                                <a class="menu-link" (click)="scrollToAnchor(0, $event)">
                                    <img class="mountain" src="assets/svg/ic-map-location.svg" alt="map-location-icon">
                                    <span class="label-with-icon">
                                      {{ 'REGION.REGIONS' | translate }} >
                                    </span>
                                </a>
                            </li>
                        }

                        @if (countryResponse?.attractions?.length || isFetching) {
                            <li>
                                <a class="menu-link" (click)="scrollToAnchor(1, $event)">
                                    <img class="sign-post" src="assets/svg/ic-sign-post.svg" alt="sign-post-icon">
                                    <span class="label-with-icon">
                                      {{ 'ATTRACTION.ATTRACTIONS' | translate }} >
                                    </span>
                                </a>
                            </li>
                        }
                    </ul>
                </div>

                <div class="info-box__popular">
                    <div class="info-box__itineraries">
                        <app-popular-itineraries
                                [showBrowseButton]="true"
                                [customTrips]="countryResponse.itineraries"
                                [infoType]="eInfoType.COUNTRY"
                                [isFetching]="isFetching"
                                (browse)="scrollToAnchor(2)"
                        ></app-popular-itineraries>
                    </div>
                </div>
            </div>

            <div class="info-box__locations" #locationsRef>
                <div class="info-box__gallery">
                    @if (!isFetching) {
                        <app-gallery
                                [isTripPlannerPage]="true"
                                [isCityPage]="false"
                                [items]="countryResponse.destinations"
                                (selectedItem)="flyToGalleryItem($event)"
                        ></app-gallery>
                    } @else {
                        <ngx-skeleton-loader
                                [theme]="{height: locationsRef.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
                    }
                </div>
                <div class="info-box__map">
                    @if (!isFetching) {
                        <app-simple-map
                                [coordinates]="countryInfoParseService.mapCoordinates$ | async | parseCoordinates"
                        ></app-simple-map>
                    } @else {
                        <ngx-skeleton-loader
                                [theme]="{height: locationsRef.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="location-info__header"></div>

    @if (countryResponse?.regions?.length || isFetching) {
        <section class="location-info" id="element-id-0">
            <div class="location-info__header">
                <h2 class="align-filter">
                    {{ 'REGION.REGIONS_IN' | translate: {country: defaultLocationName | replaceStr: ' ' | titlecase} }}
                </h2>
                <app-search-input-field
                        [disabled]="isFetching"
                        [placeholder]="'REGION.REGION' | translate"
                        (searchChanged)="countryResponse.filterAndSortRegions($event)"
                ></app-search-input-field>
            </div>
            <div class="location-info__content">
                <app-location-list
                        [data]="countryResponse.regionsSearchedAndSorted"
                        [dataType]="eInfoType.REGION"
                        [country]="defaultLocationName"
                        [isFetching]="isFetching"
                ></app-location-list>
            </div>
            <div class="location-info__footer"></div>
        </section>
    }

    @if (countryResponse?.attractions?.length || isFetching) {
        <section class="location-info" id="element-id-1">
            <div class="location-info__header">
                <h2 class="align-filter">
                    {{ 'ATTRACTION.ATTRACTION_IN' | translate: {country: defaultLocationName | replaceStr: ' ' | titlecase} }}
                </h2>
                <app-search-input-field
                        [placeholder]="'ATTRACTION.ATTRACTION' | translate"
                        [disabled]="isFetching"
                        (searchChanged)="countryResponse.filterAndSortAttractions($event)"
                ></app-search-input-field>
            </div>
            <div class="location-info__content">
                <app-places-list
                        [places]="countryResponse.attractionsSearchedAndSorted"
                        [isAttractions]="true"
                        [isFetching]="isFetching"
                ></app-places-list>
            </div>
            <div class="location-info__footer"></div>
        </section>
    }

    @if (countryResponse.itineraries?.length || isFetching) {
        <section class="location-info" id="element-id-2">
            <div class="location-info__header">
                <h2>{{ 'DESTINATION.POPULAR_TRIPS_IN' | translate: {country: defaultLocationName | replaceStr: ' ' | titlecase} }}</h2>
            </div>
            <div class="location-info__content">
                <app-trips-list
                        [trips]="countryResponse.itineraries"
                        [country]="countryDetails.name"
                        [isFetching]="isFetching"
                ></app-trips-list>
            </div>
        </section>
    }
</div>
